import { render, staticRenderFns } from "./RelatorioIJ.vue?vue&type=template&id=e3b27f7e&"
import script from "./RelatorioIJ.vue?vue&type=script&lang=js&"
export * from "./RelatorioIJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports